import {utf16_to_b64} from "../service/b64utf16";

export const newUser = {
    username : '',
    password : ''
}

export function basicToken(user){
    return "BASIC "+ utf16_to_b64(user.username + ":"+ user.password);
}